export var LineSeparatorLineVariantType;
(function (LineSeparatorLineVariantType) {
    /**
     * @deprecated
     * This variant is deprecated and will be removed in the future. Use REGULAR_HORIZONTAL instead.
     */
    LineSeparatorLineVariantType["DEFAULT_HORIZONTAL"] = "DEFAULT_HORIZONTAL";
    /**
     * @deprecated
     * This variant is deprecated and will be removed in the future. Use REGULAR_VERTICAL instead.
     */
    LineSeparatorLineVariantType["DEFAULT_VERTICAL"] = "DEFAULT_VERTICAL";
    LineSeparatorLineVariantType["REGULAR_HORIZONTAL"] = "REGULAR_HORIZONTAL";
    LineSeparatorLineVariantType["REGULAR_VERTICAL"] = "REGULAR_VERTICAL";
    LineSeparatorLineVariantType["MAIN_SECTION_HORIZONTAL"] = "MAIN_SECTION_HORIZONTAL";
    LineSeparatorLineVariantType["MAIN_SECTION_VERTICAL"] = "MAIN_SECTION_VERTICAL";
    LineSeparatorLineVariantType["DECORATIVE_HORIZONTAL"] = "DECORATIVE_HORIZONTAL";
    LineSeparatorLineVariantType["DECORATIVE_VERTICAL"] = "DECORATIVE_VERTICAL";
})(LineSeparatorLineVariantType || (LineSeparatorLineVariantType = {}));
export var LineSeparatorLabelVariantType;
(function (LineSeparatorLabelVariantType) {
    LineSeparatorLabelVariantType["LABEL_DEFAULT"] = "LABEL_DEFAULT";
})(LineSeparatorLabelVariantType || (LineSeparatorLabelVariantType = {}));
//# sourceMappingURL=variants.js.map